const logotext = "KELLY";
const meta = {
  title: "Kelly Owoju",
  description:
    "I’m John Doe Software Developer _ Full stack devloper, currently working at Uridium Tech",
};

const introdata = {
  title: "I’m Kelly Owoju",
  animated: {
    first: "I love coding",
    second: "I code cool websites",
    third: "I develop mobile apps",
  },
  description:
    "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.",
  your_img_url: "https://i.ibb.co/qnMRVNc/my-image.png",
};

const dataabout = {
  title: "A lil bit about myself",
  aboutme:
    "Experienced software developer with focus on frontend development using ReactJS, NextJS, and React Native. Also have some backend experience, having worked as fullstack developer on various personal projects. Zeal for learning and problem-solving drives constant improvement and excellence in work.",
};

const worktimeline = [
  {
    jobtitle: "Frontend React Native developer",
    where: "Uridium Technologies, Nigeria",
    date: "2022",
  },
  {
    jobtitle: "Frontend ReactJS Developer",
    where: "Phrone Technologies",
    date: "2020",
  },
  {
    jobtitle: "Fullstack React and Firebase Developer",
    where: "Coincreaze ltd",
    date: "2019",
  },
];

const skills = [
  {
    name: "HTML/CSS",
    value: 100,
  },
  {
    name: "Javascript",
    value: 85,
  },
  {
    name: "React",
    value: 95,
  },
  {
    name: "React Native",
    value: 90,
  },
  {
    name: "NodeJS",
    value: 90,
  },
  {
    name: "Restful APIs",
    value: 90,
  },
  {
    name: "Firebase",
    value: 93,
  },
  {
    name: "Git/Github",
    value: 93,
  },
];

const services = [
  {
    title: "Responsive and Scalable Web Apps",
    description:
      "I provide website solutions or services to clients, as I am solely concerned about my client's online identity, leading to a topnotch delivery of unique and valuable web app solutions.",
  },
  {
    title: "Mobile Apps",
    description:
      "I provide website solutions or services to clients, as I am solely concerned about my client's online identity, leading to a topnotch delivery of unique and valuable web app solutions.",
  },
  {
    title: "Python Program Softwares",
    description:
      "I provide website solutions or services to clients, as I am solely concerned about my client's online identity, leading to a topnotch delivery of unique and valuable web app solutions.",
  },
];

const dataportfolio = [
  {
    img: "https://i.ibb.co/FgmPLky/writefrenzy.png",
    desctiption: "A writing tool with ChatGPT3",
    link: "https://writing-toool.web.app/",
  },
  {
    img: "https://i.ibb.co/L9HXX6k/hiresset.png",
    desctiption: "A working Freelance website",
    link: "https://hiresset.web.app/",
  },
  {
    img: "https://i.ibb.co/fN6b1jb/managefunds-screenshot.png",
    desctiption: "Business management UI",
    link: "https://manage-fund.web.app/",
  },
  {
    img: "https://i.ibb.co/DYVst5g/coinpont.png",
    desctiption: "A Token Bridger Landing Page",
    link: "https://coinponte.web.app/",
  },
  {
    img: "https://i.ibb.co/5cYbg17/coincreaze-screenshot.png",
    desctiption: "Coincreaze Crypto Currency Investment",
    link: "https://coincrease-investment.web.app/",
  },
];

const contactConfig = {
  YOUR_EMAIL: "kellyowoju@gmail.com",
  YOUR_FONE: "(+234)90-4472-5708",
  description: "Your reach would be attended to almost instantly. Send away. ",
  YOUR_SERVICE_ID: "service_qw7b0ah",
  YOUR_TEMPLATE_ID: "template_j5gvkkr",
  YOUR_USER_ID: "qzThrrTtiWo3MAir7",
};

const socialprofils = {
  github: "https://github.com/Kellie-Brighty",
  facebook: "https://facebook.com",
  linkedin: "https://linkedin.com/in/kelly-owoju",
  twitter: "https://twitter.com/Kelly69070471",
  youtube: "https://youtube.com",
  twitch: "https://twitch.com",
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
